<template>
  <div class="login_modal_box">
    <a-modal
      v-model:visible="visible"
      centered
      :footer="null"
      :maskClosable="false"
      forceRender
      @cancel="cancel">
      <div class="login_box">
        <a-tabs
          v-model:activeKey="loginIndex"
          centered
          :tabBarStyle="{ fontSize: '20px' }">
          <a-tab-pane key="1" tab="登录"></a-tab-pane>
          <a-tab-pane key="2" tab="注册"></a-tab-pane>
        </a-tabs>

        <div class="login_content_box">
          <div class="login_form_box" v-show="loginIndex == '1'">
            <a-form
              name="loginForm"
              ref="loginForm"
              :model="formLoginData"
              :rules="formRulesData">
              <a-form-item label="" name="account">
                <a-input
                  v-model:value="formLoginData.account"
                  size="large"
                  :maxlength="18"
                  placeholder="请输入手机号/身份证号">
                  <template #prefix>
                    <span class="s1"><user-outlined /></span>
                  </template>
                </a-input>
              </a-form-item>
              <a-form-item label="" name="password">
                <a-input-password
                  v-model:value="formLoginData.password"
                  size="large"
                  :maxlength="20"
                  placeholder="请输入登录密码">
                  <template #prefix>
                    <span class="s1"><lock-outlined /></span>
                  </template>
                </a-input-password>
              </a-form-item>
            </a-form>
            <div class="form_btn">
              <a-button
                type="primary"
                block
                size="large"
                :loading="loginLoading"
                @click="loginSubmitChange"
                >登录</a-button
              >
            </div>

            <div class="tip">
              <span>未注册用户请先完成注册</span>
              <span class="forget-password" @click="forgerHandle">忘记密码</span>
            </div>
          </div>
          <div class="register_form_box" v-show="loginIndex == '2'">
            <RegisterBox
              ref="registerPageBox"
              @registerSuccess="registerSuccess"></RegisterBox>
          </div>
        </div>
      </div>
    </a-modal>

    <forgetPassword ref="forgetPasswordRef" />
  </div>
</template>

<script setup>
import { ref, watch, computed, onMounted } from "vue";
import { UserOutlined, LockOutlined } from "@ant-design/icons-vue";
import RegisterBox from "./register.vue";
import { getRsa, getRsaKey } from "@/utils/function.js";
import { studentAccountlogin } from "@/api/login.js";
import { getStudentInfo } from "@/api/user.js";
import { message } from "ant-design-vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import forgetPassword from "./forget-password";
const router = useRouter();
const store = useStore();

// const visible = ref(false);
const visible = computed(() => store.getters["data/getLoginState"]);
const loginIndex = ref("1");

onMounted(() => {
  getRsaKey();

  //   let access_token = localStorage.getItem("access_token2");
  //   console.log("access_token===", access_token);
  //   if (access_token) {
  //     getUserInfoData();
  //   }
});

// 登录表单信息
const loginForm = ref(null);
const formLoginData = ref({
  // account:"420504198301273771",
  // password: "123456Aa",
});
const formRulesData = ref({
  account: [{ required: true, message: "请输入身份证号" }],
  password: [{ required: true, message: "请输入登录密码" }],
});
const loginLoading = ref(false);

// 登录
async function loginSubmitChange() {
  loginLoading.value = true;
  loginForm.value
    .validate()
    .then(async (result) => {
      // console.log("=====", formLoginData.value);

      let { account, password } = formLoginData.value;
      const { stage, vx, paymentId } = await studentAccountlogin({
        account: await getRsa(account),
        password: await getRsa(password),
      });
      // console.log("vx====", vx);
      localStorage.setItem("access_token2", vx);

      loginLoading.value = false;
      getUserInfoData();
    })
    .catch((err) => {
      loginLoading.value = false;
      console.log("err==", err);
    });
}

const registerPageBox = ref(null);
const loginChange = (type) => {
  loginIndex.value = type;
  //   visible.value = true;
  open();
  registerPageBox.value.resettingChange();
};

// 注册之后触发的事件
function registerSuccess() {
  // console.log("注册成功！");
  // registerPageBox.value.resettingChange();
  // loginIndex.value = "1";
  getUserInfoData();
}

// 获取用户信息
async function getUserInfoData(params) {
  let userInfo = await getStudentInfo();
  // console.log("====userInfo", userInfo);
  if (userInfo) {
    cancel();
    localStorage.setItem("userInfo2", JSON.stringify(userInfo));
    store.commit("data/SET_USER_INFO2", userInfo);
    // console.log("getUserInfo===", store.getters["data/getUserInfo2"]);
    router.push({
      path: "/myPage",
    });
  }
}

function open() {
  store.commit("data/SET_LOGIN_STATE", true);
}
function cancel() {
  store.commit("data/SET_LOGIN_STATE", false);
}

watch(
  () => loginIndex.value,
  (newVal) => {
    // console.log("newVal====", newVal);
    registerPageBox.value.stepIndexChange();
  }
);
defineExpose({
  loginChange,
});

const forgetPasswordRef = ref(null);
function forgerHandle() {
  forgetPasswordRef.value.visible = true;
}
</script>

<style lang="scss">
@import "@/style/var.scss";
.login_box {
  width: 100%;
}

/deep/.ant-tabs-tab {
  padding-left: 12px;
  padding-right: 12px;
  line-height: 1.2;
  font-size: 18px;
}

.login_content_box {
  padding: 30px 50px 0;
  .form_btn {
    padding: 10px 0 30px;
  }
  .s1 {
    margin-right: 4px;
  }

  .tip {
    display: flex;
    justify-content: space-between;

    .forget-password {
      cursor: pointer;
      color: #1890ff;
    }
  }
}
</style>
